import React from 'react'

import { RatingItemComponent } from '../../components'
import { useRatingscontent } from '../../hooks'
import { SectionContainer } from '../../layouts'
import { ContentParser } from '../../utils/helpers'
import {
  awarnessContent,
  backgroundClassName,
  headingContainerStyling,
  headingStyling,
  ratingContainer,
  ratingContent,
} from './AwernessSection.module.css'

const NewAwernessSection = ({ lang, slice }) => {
  const ratingsData = useRatingscontent()
  const localizedRatingsData = ratingsData.filter(
    (item) => item.language.slug === lang,
  )
  const { ratingscontent } = localizedRatingsData[0]
  const { heading } = ratingscontent
  const { containerwidth } = slice
  const ratings = ContentParser(ratingscontent, 'rating')

  return (
    <SectionContainer
      containerwidth={containerwidth}
      extraClassName={backgroundClassName}
      extraContentClassName={awarnessContent}
      extraHeadingClassName={headingStyling}
      extraHeadingContainerClassName={headingContainerStyling}
      heading={heading}
      withHeader
      withParagraph
    >
      <div className={ratingContainer}>
        {ratings.length > 0 && (
          <ul className={ratingContent}>
            {ratings.map((rating, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <RatingItemComponent {...rating} key={index} image={index} />
              )
            })}
          </ul>
        )}
      </div>
    </SectionContainer>
  )
}

export default NewAwernessSection
